import { render, staticRenderFns } from "./UcInvoiceMiniCard.yaml?vue&type=template&id=143bb814&component"
import script from "./UcInvoiceMiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./UcInvoiceMiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports